import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import { BillingService2 } from "../billing.service";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {FilterParams} from "app/models/filter_form.model";
import {ChartParams} from "app/views/chart/chart.component";
import {EventsService} from "app/lib/EventsService";

import {BaseComponent} from "app/views/base.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {parseDate} from "app/lib/lib";
import {HelperService} from "app/lib/helper.service";
import merge from 'lodash-es/merge';
import {RefDetailComponent} from "../../views/referers/ref_detail.component";
import {RefService} from "../../views/referers/ref.service";
import {AlertComponent} from "../../views/modal/alert.component";
import { UserService } from "../../user/user.service";
import { IStatResult } from "../../models/responce_result.model";
import * as moment from 'moment-timezone';

interface IRefererColumn {
	columnName: string;
	data: {
		paidCount: number;
		userCount: number;
		siteCount: number;
		userPaidCount: number;
		conversion: number;
	};
}

interface IRefererRow {
	rowName: string;
	columns: IRefererColumn[];
	totalUserCount: number;
	
	parent: IRefererRow;
	
	_isLoad: boolean;
	
	refGroup: string;
}


interface StatsResult extends IStatResult {
	stats;
	rowNames;
	columnNames;
}

@Component({
	selector: 'app-conversion-source',
	templateUrl: './conversion-source.component.html',
})
export class ConversionSourceComponent extends BaseComponent {
	links = [];
	stats: IRefererRow[];
	
	totalLoader: boolean = false;
	paginationLoader: boolean = false;
	statsLoader: boolean = false;
	
	chart: ChartParams = new ChartParams();
	chart2: ChartParams = new ChartParams();
	chartSmallSource: ChartParams = new ChartParams();
	tableChart: ChartParams = new ChartParams();
	
	total: any;
	
	public dontLoad: any = {};
	
	public rowNames: string[] = [];
	public columnNames: string[] = [];
	public baseUrl: string = this.router.url.split('?')[0];
	public currentFP: FilterParams;
	
	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTo', 'datePublished'],
		processorType: 'all',
		dateType: 'dateCreated',
		userRegType: 'usersWithSite',
		user21billingEnd: 21,
		year: moment().year(),
		period: 'month',
	};
	
	years: number[] = [];
	year: number = parseDate().year();
	
	constructor(
		public eventsService: EventsService,
		public service2: BillingService2,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public refService: RefService,
		public route: ActivatedRoute,
		public userService: UserService,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		this.route.queryParams.subscribe((params: any) => {
			this.currentFP = params;
		});
		
		for (let yyyy = 2017; yyyy <= this.year; yyyy++) {
			this.years.unshift(yyyy);
		}
		
		this.filter.addFilters.push('promocode');
		
		
		this.chart2.setOptions({
			names: {
				pureConversion: 'Конверсия юзеров в платников'
			},
			axis: {
				y: {
					show: true,
					// max: 100,
					label: {
						text: 'Проценты',
						position: 'outer-middle'
					},
					tick: {
						format: function (y) {
							return y + ' %';
						}
					}
				}
			},
		})

		this.chart.setOptions({
			showLabels: ['Yandex Direct', 'Leshin trafic', 'Direct', 'Ucoz Main', 'Search organic', 'Google Adwords', 'affiliates.ukit.com']
		})
	}
	
	
	async getData() {
		this.year = this.filter.filterParams.year || parseDate().year();
		
		this.filter.filterParams.paginationDate = parseDate([this.year, 0, 1]).format('YYYY-MM-DD HH:mm:ss');

		await this.getChart2();
		await this.getStats();
		await this.getChart();
		await this.getTableChart();
		await this.getChartSmallSource();
	}
	
	async getChart2() {
		const me = this;
		
		me.chart2.showLoader();
		const { charts: charts2 } = await me.service2.conversionSource.chart(
			me.filter.getFilterParams(),
			'charts2'
		).toPromise();

		me.chart2.data = charts2;
		me.chart2.hideLoader();
	}
	
	async getChart() {
		const me = this;
		
		me.chart.showLoader();
		const { charts } = await me.service2.conversionSource.chart(
			me.filter.getCopyFilterParams({
				chartType: 'conversion',
			})
		).toPromise();
		
		me.chart.data = charts;
		me.chart.hideLoader();
	}

	async getChartSmallSource() {
		const me = this;

		me.chartSmallSource.showLoader();
		const { charts } = await me.service2.conversionSource.chartSmallSource(
			me.filter.getCopyFilterParams({
				chartType: 'conversion',
			}),
			'chartSmallSource'
		).toPromise();

		me.chartSmallSource.data = charts;
		me.chartSmallSource.hideLoader();
	}
	
	async getStats(fp?: FilterParams) {
		const me = this;
		
		me.statsLoader = true;
		const { stats, rowNames, columnNames } = await me.service2.conversionSource.stats<StatsResult>(
			fp || me.filter.filterParams
		).toPromise();
		me.statsLoader = false;
		
		me.rowNames = rowNames;
		me.columnNames = columnNames;
		me.stats = <IRefererRow[]>stats;
	}
	
	async userRegTypeChange() {
		await this.getStats();
	}
	
	
	async onClickByGroup(group: IRefererRow) {
		const me = this;
	
		const refGroup = group.rowName;
		const fp = me.filter.getCopyFilterParams();
		
		// Если есть parent - значит кликнули по источнику.
		// И нужно показать окно с детализацией как в reg_day
		const isUnGrouped = me.refService.isUnGrouped(group.rowName);
		
		if (group.parent || isUnGrouped) {
			const dateM = parseDate(me.filter.filterParams.paginationDate);
			const start = dateM.format('DD-MM-YYYY');
			const end = dateM.endOf('year').format('DD-MM-YYYY');
			
			let params = merge({}, fp, {
				reportType: 'reg_day',
				dateFilterParams: {
					dateCreated: {
						type: 'other',
						start: start,
						end: end,
					}
				},
				dateType: 'dateCreated',
			});
			
			let title = '';
			
			// Тут и в "referers/ref.component.ts" идентичные по смыслу проверки.
			if (isUnGrouped) {
				params.refGroup = group.rowName;
				title = group.rowName;
			} else {
				params.refGroup = group.parent;
				params.refSource = group.refGroup;
				title = `${group.parent} - ${refGroup}`;
			}
			
			group._isLoad = true;
			const { stats } = await me.userService.reg_day.detail(params).toPromise();
			group._isLoad = false;
			
			this.modalService.open(RefDetailComponent, {
				title,
				stats,
			}, { size: 'hg' });
			
			return ;
		}
		
		const i = me.stats.findIndex(g => g.rowName === refGroup);
		// @ts-ignore
		const subGroupCount = me.stats.reduce((c, s) => c + (s.parent === refGroup ? 1 : 0), 0);
		
		if (subGroupCount > 0) {
		
			// close
			me.stats.splice(i + 1, subGroupCount);
			
			return;
		}
		
		group._isLoad = true;
		
		// Тут избыточность в inGroup, пока так.
		fp.refGroup = refGroup;
		fp.inGroup = refGroup;
		
		const { stats, rowNames, columnNames } = await me.service2.conversionSource.stats<StatsResult>(fp).toPromise();
		
		stats.forEach(s => s.parent = refGroup);
		
		me.stats = [
			...me.stats.slice(0, i + 1),
			...stats,
			...me.stats.slice(i + 1),
		];
		
		console.log('showSource', group, {i, stats, rowNames, columnNames});
		
		group._isLoad = false;
	}
	
	
	downloadStats() {
		window.location.href = this.service2.conversionSource.downloadFileRoute(
			this.filter.filterParams,
			'csv'
		);
		
		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}
	
	getQueryParams(p) {
		return merge({}, this.currentFP, { ...p, page: 1 });
	}
	
	
	getTooltipText(column: IRefererColumn) {
		return `100 * ${ column.data.userPaidCount } / ${ column.data.userCount }`;
	}
	
	// TODO Вынести в pipe
	// ибо ангуля при каждом чихе будет дергать эту функцию для всех строк
	getRowClass(group: IRefererRow): string {
		if (group.parent) {
			return ''
		}
		
		if (group.rowName === 'total') {
			return 'table-info';
		}
		
		if (this.refService.isUnGrouped(group.rowName)) {
			return 'table-warning';
		}
		
		return 'table-success';
	}
	
	// TODO Прикрыть delimeter, задержку ввода и чтобы срабатывало без потери фокуса
	async onChangeBillingEnd() {
		await this.getStats();
	}
	
	async getTableChart() {
		const me = this;

		me.tableChart.showLoader();
		const { charts } = await me.service2.conversionSource.chart(
			me.filter.getCopyFilterParams({
				chartType: 'userCount',
			})
		).toPromise();

		me.tableChart.data = charts;
		me.tableChart.hideLoader();
	}
}

